import React from 'react';
import Filters from './../Filters';
import PropTypes from 'prop-types';
import { Tooltip } from 'antd';
import i18n from '../../Shared/Translation/i18n';
/**
 * the wrapper of main list pages with filters
 * @param {any} props
 */
export default function MainListWrapper(props) {
    const {
        children,
        filters,
        newButton,
        appliedFilter,
        setAppliedFilter,
        loadData,
        clearFilter,
        showRefreshButton,
        pagination,
        setPagination,
        isListView
    } = props;


    return isListView ? 
        <view>
            {(showRefreshButton || filters) && <toolbar>
                {filters && <action>
                    <div className='button'><text>{i18n('text.filter')}</text></div>
                </action>}
                {showRefreshButton && <action right="">
                    <div onClick={loadData} className={'button'}><text>{i18n('text.refresh')}</text></div>
                </action>}
            </toolbar>}
            {children}
        </view> : 
        <container>
            { showRefreshButton && 
                <toolbar light='' shadow=''>
                    <>
                        <Tooltip title={i18n('text.refresh')}>
                            <div className='button accent' onClick={loadData}><text>{i18n('text.refresh')}</text></div>
                        </Tooltip>
                    </>
                </toolbar>
            }
            <view vertical='' adaptive='' >
                {filters && <Filters
                    clear={clearFilter}
                    appliedFilter={appliedFilter}
                    filters={filters}
                    setAppliedFilter={setAppliedFilter}
                    setPagination={setPagination}
                    pagination={pagination}
                />}
                <view>
                    {newButton}
                    {children}
                </view>
            </view>
        </container>;
}


MainListWrapper.propTypes = {
    filters: PropTypes.array,
}

MainListWrapper.defaultProps = {
    filters: null,
}